import { create } from 'zustand'

import { UIState } from '../types/ui'

interface UIStore extends UIState {
  // Message Actions
  showMessage: (
    type: UIState['messages'][0]['type'],
    text: string,
    autoHide?: boolean
  ) => void
  removeMessage: (messageId: string) => void
  clearMessages: () => void

  // Loading Actions
  setLoading: (isLoading: boolean, text?: string) => void

  // Utility Actions
  showSuccess: (text: string) => void
  showError: (text: string) => void
  showInfo: (text: string) => void
  showWarning: (text: string) => void
}

export const useUIStore = create<UIStore>((set, get) => ({
  // Initial state
  messages: [],
  isLoading: false,
  loadingText: undefined,

  // Message Actions
  showMessage: (type, text, autoHide = true) => {
    const id = Date.now().toString() + Math.random().toString(36).substr(2, 9)
    const newMessage = {
      id,
      type,
      text,
      timestamp: new Date(),
      autoHide
    }

    set((state) => ({
      messages: [...state.messages, newMessage]
    }))

    // 自动隐藏消息
    if (autoHide) {
      setTimeout(() => {
        get().removeMessage(id)
      }, 3000)
    }
  },

  removeMessage: (messageId) => {
    set((state) => ({
      messages: state.messages.filter((msg) => msg.id !== messageId)
    }))
  },

  clearMessages: () => {
    set({ messages: [] })
  },

  // Loading Actions
  setLoading: (isLoading, text) => {
    set({
      isLoading,
      loadingText: isLoading ? text : undefined
    })
  },

  // Utility Actions
  showSuccess: (text) => {
    get().showMessage('success', text)
  },

  showError: (text) => {
    console.error('Error message:', text)
    get().showMessage('error', text)
  },

  showInfo: (text) => {
    get().showMessage('info', text)
  },

  showWarning: (text) => {
    get().showMessage('warning', text)
  }
}))
